import ToolbarButton from "../ToolbarButton";
import SortBy from "../SortBy";
import { SearchResultsFormatType } from "../useSearchListingsPage";
import { Filter, SquareCheck, Heart } from "lucide-react";
import Pagination from "../Pagination";
import PageSize from "../PageSize";
import { createSearchResultsFormatSelector } from "./utils";
import { Listing } from "src/types/listing";

export const DesktopSearchToolbar = ({
  setMapCenter,
  setSearchResultsFormat,
  searchResultsFormat,
  selectedPageListing,
  scrollToItemWithId,
  onSelectListing,
  listings,
  selectedSort,
  onSearchParamsUpdated,
  currentFeature,
  nextFeature,
  isLastFeature,
  totalRecords,
  pageSize,
  currentPage,
  onFilterButtonClick,
  isSuppressSearchResultsFormatSelector = false,
  isSuppressFilterButton = false,
  isSuppressSortBy = false,
  isBatchSelectionActive = false,
  onBatchSelectionToggle,
  isFavoritesOnly = false,
  onFavoritesOnlyToggle,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setMapCenter?: (center: any) => void;
  setSearchResultsFormat?: (format: SearchResultsFormatType) => void;
  searchResultsFormat: SearchResultsFormatType;
  selectedPageListing: Listing;
  scrollToItemWithId?: (id: string) => void;
  onSelectListing?: (listing: Listing) => void;
  listings: Listing[];
  selectedSort: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSearchParamsUpdated: (params: any) => void;
  currentFeature: string | undefined;
  nextFeature: () => void;
  isLastFeature: boolean;
  isBatchSelectionActive?: boolean;
  totalRecords: number;
  pageSize: number;
  currentPage: number;
  onFilterButtonClick?: () => void;
  isSuppressSearchResultsFormatSelector?: boolean;
  isSuppressFilterButton?: boolean;
  isSuppressSortBy?: boolean;
  onBatchSelectionToggle?: () => void;
  isFavoritesOnly?: boolean;
  onFavoritesOnlyToggle?: () => void;
}) => {
  const isShowToolbar1 =
    !isSuppressSearchResultsFormatSelector ||
    !isSuppressSortBy;
  return (
    <div className={`desktop-search-toolbar hidden md:flex items-center gap-1 flex-wrap mt-2`}>
      <div className="gap-3 flex flex-wrap items-center">
        {onBatchSelectionToggle && (
          <ToolbarButton
            onClick={onBatchSelectionToggle}
            icon={<SquareCheck />}
            isActive={isBatchSelectionActive}
            tooltipContent="Select properties"
          />
        )}
        {onFavoritesOnlyToggle && (
          <ToolbarButton
            onClick={onFavoritesOnlyToggle}
            icon={<Heart className={`w-4 h-4 text-red-500 ${isFavoritesOnly ? "fill-red-500" : ""}`} />}
            isActive={isFavoritesOnly}
          />
        )}
        {!isSuppressFilterButton && onFilterButtonClick && (
          <ToolbarButton onClick={onFilterButtonClick} icon={<Filter className="w-4 h-4" />}>
            Filters
          </ToolbarButton>
        )}
        {isShowToolbar1 && (
          <div className="toolbar-1 flex gap-3 w-auto items-center">
            {!isSuppressSearchResultsFormatSelector &&
              setSearchResultsFormat && (
                <div>
                  {createSearchResultsFormatSelector({
                    isShowSearchResultsFormatTypeDiscoveryTooltip:
                      currentFeature === "search-results-format-desktop",
                    isShowMyLocationDiscoveryTooltip:
                      currentFeature === "my-location-button-desktop",
                  })({
                    searchResultsFormat,
                    setSearchResultsFormat,
                    setMapCenter,
                    selectedPageListing,
                    scrollToItemWithId,
                    onSelectListing,
                    listings,
                    currentFeature,
                    nextFeature,
                    isLastFeature,
                  })}
                </div>
              )}
            {!isSuppressSortBy && (
              <SortBy
                value={selectedSort}
                onChange={(value: { sort: string; sort_dir: string }) => {
                  onSearchParamsUpdated({
                    sortField: value.sort,
                    sortDir: value.sort_dir,
                  });
                }}
              />
            )}
          </div>
        )}
        <div className="flex gap-3 w-auto items-center">
          <PageSize
            value={String(pageSize)}
            onChange={(value: string) => {
              onSearchParamsUpdated({
                pageSize: Number(value),
                currentPage: 1,
              });
            }}
          />
          <Pagination
            numRecords={totalRecords}
            pageSize={pageSize}
            currentPage={currentPage}
            onPageChange={(updatedPage: number) => {
              onSearchParamsUpdated({ currentPage: updatedPage });
            }}
          />
        </div>
      </div>
    </div>
  );
};
